import { render, staticRenderFns } from "./SportelloContrattiFuturiView.vue?vue&type=template&id=271b9783&"
import script from "./SportelloContrattiFuturiView.vue?vue&type=script&lang=ts&"
export * from "./SportelloContrattiFuturiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports